import { type Image } from '@/api/accommodation/types'
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from '@/components/ui/drawer'

interface MobileGallerySheetProps {
  images: Image[]
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  initialIndex?: number
}

export function MobileGallerySheet({ images, isOpen, onOpenChange }: MobileGallerySheetProps) {
  // Group images by description (room name)
  const groupedImages = images.reduce(
    (acc, image) => {
      const key = image.description || 'Ostatní'
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push(image)
      return acc
    },
    {} as Record<string, Image[]>,
  )

  // Sort groups by priority of first image in each group
  const sortedGroups = Object.entries(groupedImages).sort(([, a], [, b]) => {
    const aPriority = Math.max(...a.map((img) => img.priority))
    const bPriority = Math.max(...b.map((img) => img.priority))
    return bPriority - aPriority
  })

  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange}>
      <DrawerContent className="h-[85dvh] overflow-hidden p-0">
        <DrawerHeader className="border-b border-slate-100 px-4 py-3">
          <DrawerTitle>Fotografie ({images.length})</DrawerTitle>
        </DrawerHeader>

        <div className="h-full overflow-y-auto pb-8">
          {sortedGroups.map(([roomName, roomImages]) => (
            <div key={roomName} className="py-4">
              <h3 className="mb-3 px-4 text-lg font-semibold text-slate-900">{roomName}</h3>
              <div className="space-y-2 px-4">
                {roomImages
                  .sort((a, b) => b.priority - a.priority)
                  .map((image, index) => (
                    <img
                      key={index}
                      src={image.url.thumbnail}
                      alt={image.description || undefined}
                      className="w-full rounded-lg object-cover"
                    />
                  ))}
              </div>
            </div>
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  )
}
